<template>
  <div>
    <div v-bind:class="'field focus' + (nonEmptyPasswords && weak ? ' error' : '')" style="position: relative;">
      <label>{{passwordLabel}}</label>
      <input
        id="password1"
        type="password"
        v-model="password1"
        placeholder="Password"
        required="true"
        :type="showPassword ? 'text' : 'password'"
        style="padding-right: 2.5rem;"
      />
      <span
        @click="togglePasswordVisibility"
        style="
        position: absolute;
        right: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 100%;
      "
      >
        <i
          :class="showPassword ? 'eye slash icon' : 'eye icon'"
          style="font-size: small; padding: 2px; margin-top: 100%;"
        ></i>
      </span>
    </div>
    <div class="field" style="position: relative;">
      <input
        id="password2"
        v-model="password2"
        :type="showPassword2 ? 'text' : 'password'"
        placeholder="Confirm password"
        required
        style="padding-right: 2.5rem;"
      />
      <span
        @click="togglePasswordVisibility2"
        style="
      position: absolute;
      right: 0.5rem;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 100%;
    "
      >
    <i
      :class="showPassword2 ? 'eye slash icon' : 'eye icon'"
      style="font-size: small;"
    ></i>
    </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    passwordLabel: {
      default: 'Password'
    }
  },
  data: function () {
    return {
      password2: '',
      showPassword: false,
      showPassword2: false,
      regex1: new RegExp('.*[_\\- !"?$%\\^&*()+={}\\[\\]:;@\'~#|<>,.?\\\\/0123456789].*'),
      regex2: new RegExp('.*[a-zA-Z].*'),
      rules: {
        password1: {
          rules: [{
            type: 'minLength[8]',
            prompt: 'Password needs to be minimum 8 characters long'
          }, {
            type: 'regExp',
            value: '.*[a-zA-Z].*',
            prompt: 'Password needs to contain a letter'
          }, {
            type: 'regExp',
            value: '.*[_\\- !"?$%\\^&*()+={}\\[\\]:;@\'~#|<>,.?\\\\/0123456789].*',
            prompt: 'Password needs to contain a digit or symbol'
          }]
        },
        password2: {
          rules: [{
            type: 'match[password1]',
            prompt: 'Passwords do not match'
          }]
        }
      }
    }
  },
  methods: {
    reset: function () {
      this.password1 = ''
      this.password2 = ''
    },
    emitPasswordChanged: function () {
      this.$emit('password-changed', { password1: this.password1, password2: this.password2 })
    },
    togglePasswordVisibility: function () {
      this.showPassword = !this.showPassword
    },
    togglePasswordVisibility2: function () {
      this.showPassword2 = !this.showPassword2
    },
  },
  computed: {
    password1: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    weak: function () {
      return this.password1.length < 8 || !this.password1.match(this.regex1) || !this.password1.match(this.regex2)
    },
    mismatch: function () {
      return this.password2 !== this.password1
    },
    nonEmptyPasswords: function () {
      return this.password1 !== '' || this.password2 !== ''
    }
  },
  watch: {
    password1: function () {
      this.emitPasswordChanged()
    },
    password2: function () {
      this.emitPasswordChanged()
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// PasswordInputPair.vue?012d21ca